import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {FileReference} from '../../class/file-reference';

@Component({
  selector: 'app-pdf-viewer-component',
  templateUrl: './pdf-viewer-component.component.html',
  styleUrls: ['./pdf-viewer-component.component.css']
})
export class PdfViewerComponentComponent implements OnInit {
  @Input()
  pdfSrc: string;

  title: string;

  @Input()
  noLayout: boolean;

  @Input()
  documentID: string;

  error: boolean;

  constructor() {
  }

  ngOnInit() {
    if (!this.pdfSrc) {
      this.pdfSrc = environment.backendUrl + '/api/file/' + this.documentID;
    }
  }

  get pdfUrl(): string {
    return this.pdfSrc;
  }

  showError() {
    this.error = true;
  }
}
